import React, { Component } from 'react';
import './index.css';
import './App.css';
import Menu from './Menu.js';
import Fade from './Fade.js';
import {HeaderInfo} from './HeaderInfo';
import Logo from './img/bubble.png';
import Cookies from 'universal-cookie';


export class LkWrapper extends Component {

    state = {

    }
    constructor(props) {
        super(props)
        this.props = props
        
        const cookies = new Cookies();
         if ( (cookies.get('tgsubs_token') == undefined)) {
       
            //window.location = '/auth'
         }
         var showLk = true;
         
        /* if (document.body.clientWidth < 990) {
          alert('К сожалению, в данный момент мы не приспособлены для работы на мобильных устройствах. Зайдите пожалуйста с ПК или ноутбука.')
         }
         else {
          showLk = false;
         }*/

         
    }

    render() {
        return (
            
          
         
            <div className='fullPage lkWrapper'>
          <div className='fullPage_leftMenu'>
              <div className='fullPage_leftMenu_logo'>
              
               <img src={Logo} /> <span className='fullPage_leftMenu_logo_text'> ClientSaver </span> 
              </div>
  
              <Menu 
              showCreatedDropdown={null} 
              setShowCreatedDropdown={null}
              showCreateDropdown={null} 
              setShowCreateDropdown={null}
               page={window.location.href.replace(process.env.REACT_APP_PANEL_SERVER, '')}/>  
          </div>
          <div className='fullPage_rightMainContent'> 
              <HeaderInfo />
              {/*<Fade show={showSuccessMsg}>
                <div className='successMessage'>
                  {successMsg}
                </div>
              </Fade>
              
              
              <Fade show={showErrorMsg}>
                <div className='errorMessage'>
                  Ошибка: {errorMsg}
                </div>
              </Fade>
        */}
              {this.props.children}
           </div>
      </div>

        
      
            
        )
    }

}